import RangePicker from './range-picker';
import './styles.scss';

export default RangePicker;
